export const SET_SELECTED_OFFER = 'SET_SELECTED_OFFER';
export const setSelectedOffer = params => ({
  type: SET_SELECTED_OFFER,
  payload: params
});

export const ADD_COMMAND = 'ADD_COMMAND';
export const ADD_COMMAND_SUCCESS = 'ADD_COMMAND_SUCCESS';
export const ADD_COMMAND_FAILURE = 'ADD_COMMAND_FAILURE';
export const addCommand = params => ({
  type: ADD_COMMAND,
  payload: params
});

export const GET_PRICES = 'GET_PRICES';
export const GET_PRICES_SUCCESS = 'GET_PRICES_SUCCESS';
export const GET_PRICES_FAILURE = 'GET_PRICES_FAILURE';

export const getPrices = params => ({ type: GET_PRICES, payload: params });

export const GET_PICKUP_POINTS = 'GET_PICKUP_POINTS';
export const GET_PICKUP_POINTS_SUCCESS = 'GET_PICKUP_POINTS_SUCCESS';
export const GET_PICKUP_POINTS_FAILURE = 'GET_PICKUP_POINTS_FAILURE';

export const getPickupPoints = params => ({
  type: GET_PICKUP_POINTS,
  payload: params
});

export const SET_PICKUP_POINT = 'SET_PICKUP_POINT';
export const setPickupPoint = pickupPoint => ({
  type: SET_PICKUP_POINT,
  payload: pickupPoint
});
